import React from "react";
import '../../CSS/Services.css';
import ServicesPage from "../composant_reutilisable/ServicesPage";
import ServiceCarousel from "../composant_reutilisable/ServiceCaroussel";

const Services = () => {
    return (
        <div className="services-container">
            <div className="services-content">
                <ServiceCarousel/>
                <ServicesPage/>
            </div>
        </div>
    );
};

export default Services;